import { type AppLinkOptions, useCanOpen } from '@luminovo/design-system';
import { useMemo } from 'react';

import { templateLinks } from '@/app/navigation/templateLinks';

import { NAVIGATION_COMMANDS_CONFIG, NavigationCommandConfig } from './navigationCommandsConfig';

/**
 * The navigation commands whose page the current user may open, for the Command Palette and the Home Quick Actions.
 * Templates opens the first template page the user may open, as the navbar's Templates entry does, and drops out
 * when there is none.
 */
export function useOpenableCommands(): NavigationCommandConfig[] {
    const canOpen = useCanOpen();

    return useMemo(
        () =>
            NAVIGATION_COMMANDS_CONFIG.flatMap((command) => {
                // Command ids are stable (navigationCommandsConfig.ts), so matching one is safe.
                const candidates: AppLinkOptions[] =
                    command.id === 'go-to-templates' ? Object.values(templateLinks) : [command.link];
                const link = candidates.find(canOpen);
                return link === undefined ? [] : [{ ...command, link }];
            }),
        [canOpen],
    );
}
